import type { ReactNode } from 'react'
import type { IconType } from '@/lib/types'
import { EmptyCard } from '@/ui/EmptyCard'
import { LoadingIndicator } from '@/ui/LoadingIndicator'

interface ConditionalListProps<T> {
    data: T[]
    isLoading: boolean
    children: ReactNode
    icon: IconType
    title: string
    subtitle: string
    buttonLabel?: string
    onButtonPress?: () => void
}

export function ConditionalList<T>({
    data,
    isLoading,
    children,
    icon,
    title,
    subtitle,
    buttonLabel,
    onButtonPress,
}: ConditionalListProps<T>) {
    if (isLoading) {
        return <LoadingIndicator />
    }

    if (data.length === 0) {
        return (
            <EmptyCard
                icon={icon}
                title={title}
                subtitle={subtitle}
                buttonLabel={buttonLabel}
                onButtonPress={onButtonPress}
            />
        )
    }

    return <>{children}</>
}
